/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabPricing from './diaglab-pricing';
import DiaglabPricingDetail from './diaglab-pricing-detail';
import DiaglabPricingUpdate from './diaglab-pricing-update';
import DiaglabPricingDeleteDialog from './diaglab-pricing-delete-dialog';

const DiaglabPricingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabPricing />} />
    <Route path="new" element={<DiaglabPricingUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabPricingDetail />} />
      <Route path="edit" element={<DiaglabPricingUpdate />} />
      <Route path="delete" element={<DiaglabPricingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabPricingRoutes;
